<template>
  <div>
    <div v-if="!isEmpty(videos)">
      <div v-for="(video, key) in videos" :key="key">
        <youtube v-if="video.type == 'youtube'" :id="video.ref.youtubeId"
          :onPlaying="onPlaying" :onPaused="onPaused" :onBuffer="onBuffer" :onEnded="onEnded"
        ></youtube>
        <!-- <iframe v-if="video.type == 'youtube'" :src="`https://www.youtube.com/embed/${video.ref.youtubeId}`"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen frameborder="0"
                style="width: 100%; height: 400px;"></iframe> -->

        <video-player v-if="video.type == 'video'" :options="{
          sources: [
            {
              src: (video.storageType == 'google_drive') ? video.values.downloadLink : video.file.link,
              type: video.mime
            }
          ],
        }" :onPlaying="onPlaying" :onPaused="onPaused" :onBuffer="onBuffer" :onEnded="onEnded"/>

        <p v-if="video.type === 'youtube'" class="help" style="margin-top: 10px;"><span class="has-text-danger font-w-600">*Catatan:</span> Progress video tidak terhitung jika pengguna mempercepat video dan berpindah halaman</p>
      </div>
    </div>
  </div>
</template>

<script>
  import VideoPlayer from '~/components/VideoPlayer';

  export default {
    components: {
      VideoPlayer
    },

    props: {
      videos: {
        type: Array,
        default: () => []
      },
      onPlaying: {
        type: Function,
        default: () => {}
      },
      onPaused: {
        type: Function,
        default: () => {}
      },
      onBuffer: {
        type: Function,
        default: () => {}
      },
      onEnded: {
        type: Function,
        default: () => {}
      },
    }
  }
</script>
